export default class ScenarioLog {
    id: number;
    dateTime: number;
    scenarioId: number;


    getDate(): Date {
        return new Date(this.dateTime * 1000);
    }


    constructor(props) {
        this.id = props.id;
        this.dateTime = props.dateTime;
        this.scenarioId = props.scenarioId;
    }

    static create() {
        return new ScenarioLog({
            id: 0,
            dateTime: 0,
            scenarioId: 0
        });
    }

    static fromLastTriggeredAt(lastTriggeredAt, scenarioId) {
        if (!lastTriggeredAt) return null;

        let dateTime;
        if (typeof lastTriggeredAt === "number") {
            // Accept either Unix seconds or milliseconds, although the V4 API
            // normally returns an ISO date-time string.
            dateTime = lastTriggeredAt > 100000000000
                ? Math.floor(lastTriggeredAt / 1000)
                : Math.floor(lastTriggeredAt);
        } else {
            const milliseconds = Date.parse(lastTriggeredAt);
            if (!Number.isFinite(milliseconds)) return null;
            dateTime = Math.floor(milliseconds / 1000);
        }

        if (!Number.isFinite(dateTime) || dateTime <= 0) return null;
        return new ScenarioLog({ id: 0, dateTime, scenarioId });
    }
}
